import React, { useState } from "react";
import Organizations from "./Organizations/Organizations";
import Projects from "./Projects/Projects";
import Users from "./Users/Users";
import Roles from "./Roles/Roles";
import { Drawer, List, ListItem, ListItemText, Box } from "@mui/material";
import "./Settings.css";

function Settings() {
  const drawerWidth = 260;

  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };

  return (
    <Box className="settingsContainer">
      <Drawer
        id="settingsDrawer"
        sx={{
          minHeight: "112vh",
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            backgroundColor: "#000000",
          },
        }}
        variant="permanent"
        anchor="left"
      >
        <List>
          {["Organizations", "Projects", "Users", "Roles"].map(
            (text, index) => (
              <ListItem
                button
                key={text}
                selected={selectedIndex === index}
                component={"div"}
                className={selectedIndex === index ? "Mui-selected" : ""}
                onClick={(event) => handleListItemClick(event, index)}
              >
                <ListItemText primary={text} />
              </ListItem>
            )
          )}
        </List>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 2 }}>
        {selectedIndex === 0 && <Organizations />}
        {selectedIndex === 1 && <Projects />}
        {selectedIndex === 2 && <Users />}
        {selectedIndex === 3 && <Roles />}
      </Box>
    </Box>
  );
}

export default Settings;
